
import React, { useState } from 'react';
import { PUBLICOS } from 'config/config';

import { useEffect } from 'react';

import { getAutoridadesPorRegion } from 'services/api';

import { toast } from '@jumbo/components/custom/Toast';
import { Dialog } from '@mui/material';
import { Button, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, FormLabel, Grid, InputLabel, Radio, RadioGroup, Select } from '@material-ui/core';
import AppTextInput from '@jumbo/components/Common/formElements/AppTextInput';
import { LABEL_INPUT_FONT_SIZE } from '../../ConstsAndUtils/utils';
import { Save } from '@material-ui/icons';

const DialogAgregar = ({ open, close, action, nResolucion,
  fechaOtorgada,
  autoridadQueDicta,
  setNResolucion,
  setFechaOtorgada,
  setAutoridadQueDicta,
  publico
}) => {

  const [autoridadesAux, setAutoridadesAux] = useState([{ value: 0, label: 'Seleccione' },])
  const [radioSelection, setRadioSelection] = useState('instalacion')

  useEffect(() => {

    if (autoridadesAux.length === 1) {
      getAutoridadesPorRegion(sessionStorage.getItem('region'))
        .then(res => {
          let aux = res.data.map(item => ({
            value: item.id,
            label: item.nombre
          }));
          setAutoridadesAux([{ value: 0, label: 'Seleccione' }, ...aux])
        })
        .catch(e => console.error(e))
        .finally(f => {

        })
    }

  }, [autoridadesAux])

  useEffect(() => {
    if (open) {
      setRadioSelection('instalacion');
    }
  }, [open]);

  const handleChangeTipo = (e) => {
    setRadioSelection(e.target.value)
  }

  return (
    <Dialog open={open} onClose={close} >
      <DialogTitle>
        Agregar Autorización sanitaria
      </DialogTitle>
      <DialogContent dividers>
        <Grid container item xs={12} spacing={2}>
          {publico === PUBLICOS ?
            <Grid item xs={12}>
              <FormControl>
                {/* <FormLabel id="demo-row-radio-buttons-group-label">Pertenece a la red</FormLabel> */}
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={radioSelection}
                  onChange={handleChangeTipo}>
                  <FormControlLabel value="instalacion" control={<Radio />} label="Autorización Sanitaria" />
                  <FormControlLabel value="demostracion" control={<Radio />} label="Demostración Sanitaria" />
                </RadioGroup>
              </FormControl>
            </Grid>
            :
            null
          }
          <Grid item xs={4}>
            <AppTextInput
              tooltip={'El formato debe ser: 111111'}
              InputLabelProps={{ style: LABEL_INPUT_FONT_SIZE, shrink: true }}
              fullWidth
              size={'small'}
              variant="outlined"
              label="Nº Resolución"
              value={nResolucion}
              onChange={e => {
                const value = e.target.value;
                const numericValue = value.replace(/^0+/, '') || '';
                if (e.target.value.length < 10 || e.target.value === '') {
                  setNResolucion(numericValue)
                }

              }}
              helperText={''}
              onBlur={() => { }}
            />
          </Grid>

          <Grid item xs={4}>
            <AppTextInput
              InputLabelProps={{ style: LABEL_INPUT_FONT_SIZE, shrink: true }}
              fullWidth
              size={'small'}
              variant="outlined"
              type={"date"}
              label="Fecha en que se otorga"
              value={fechaOtorgada}
              onChange={e => {

                const selectedDate = new Date(e.target.value);
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                selectedDate.setHours(0, 0, 0, 0);
                const selectedDateString = selectedDate.toISOString().split('T')[0];
                const todayString = today.toISOString().split('T')[0];

                if (selectedDateString >= todayString) {
                  toast.error('La fecha no puede ser futura')
                } else {
                  const inputDate = e.target.value;
                  const cleanedDate = inputDate.replace(/\D/g, '');
                  if (cleanedDate.length <= 2) {
                    setFechaOtorgada(cleanedDate)
                  } else if (cleanedDate.length <= 4) {
                    setFechaOtorgada(cleanedDate.slice(0, 2) + '/' + cleanedDate.slice(2))
                  } else {
                    setFechaOtorgada(cleanedDate.slice(0, 2) +
                      '/' +
                      cleanedDate.slice(2, 4) +
                      '/' +
                      cleanedDate.slice(4, 8))
                  }
                  setFechaOtorgada(e.target.value)
                }
              }}
              helperText={''}
              onBlur={() => { }}
            />
          </Grid>

          <Grid item xs={4}>

            <FormControl size='small' fullWidth>
              <InputLabel
                inputlabelprops={{ style: LABEL_INPUT_FONT_SIZE, shrink: true }}
                htmlFor="grouped-native-select"
                style={{ marginTop: -7, marginLeft: 15, fontSize: 14 }}>
                Autoridad que la dicta
              </InputLabel>
              <Select
                inputlabelprops={{ style: LABEL_INPUT_FONT_SIZE, shrink: true }}
                native
                label='Autoridad que la dicta'
                id="grouped-native-select"
                fullWidth
                variant='outlined'
                value={autoridadQueDicta}
                onChange={(e) => {
                  setAutoridadQueDicta(parseInt(e.target.value))
                }}

              >
                {
                  autoridadesAux.map((option, index) => {
                    return <option key={index + 1} value={option.value}>
                      {option.label}
                    </option>
                  })
                }
              </Select>
            </FormControl>

          </Grid>

        </Grid>

      </DialogContent>
      <DialogActions >
        <Button onClick={close}variant="outlined">
          Cancelar
        </Button>
        <Button onClick={() => {
          action(radioSelection)
          setRadioSelection('instalacion')
        }}
          color="primary" variant="outlined"
          disabled={fechaOtorgada === '' || autoridadQueDicta === 0 || nResolucion === '' ? true : false}
        >
          <Save style={{marginRight:10}} />
          Aceptar
        </Button>
      </DialogActions>
    </Dialog>
  )

}

export default DialogAgregar